'use strict';

import Rellax from 'rellax';
import debounce from './debounce';

export function defochtelParallaxSectionHeader() {
	const sectionHeader = document.querySelector('.section-header--gallery');

	if (!sectionHeader) {
		return;
	}

	let rellax1, rellax2, rellax3, rellax4;

	const resetInstances = () => {
		for (const rellax of [rellax1, rellax2, rellax3, rellax4]) {
			if (typeof rellax === 'object') {
				rellax.destroy();
			}
		}
	};
	const init = () => {
		// Reset all instances before initializing.
		// This is to prevent the rellax objects from display incorrectly when resizing the window.
		resetInstances();

		if (window.innerWidth >= 1536) {
			rellax1 = new Rellax('.gallery-item-1', {
				speed: -1.5,
				center: true,
			});

			rellax2 = new Rellax('.gallery-item-2', {
				speed: 1,
				center: true,
			});

			rellax3 = new Rellax('.gallery-item-3', {
				speed: 0.5,
				center: true,
			});

			rellax4 = new Rellax('.gallery-item-4', {
				speed: 4,
				center: true,
			});
		} else if (window.innerWidth >= 1280) {
			rellax1 = new Rellax('.gallery-item-1', {
				speed: -1,
				center: true,
			});

			rellax2 = new Rellax('.gallery-item-2', {
				speed: 1,
				center: true,
			});

			rellax3 = new Rellax('.gallery-item-3', {
				speed: 0.5,
				center: true,
			});

			rellax4 = new Rellax('.gallery-item-4', {
				speed: 4,
				center: true,
			});
		} else if (window.innerWidth >= 1024) {
			rellax1 = new Rellax('.gallery-item-1', {
				speed: -0.5,
				center: false,
			});

			rellax2 = new Rellax('.gallery-item-2', {
				speed: 1,
				center: true,
			});

			rellax4 = new Rellax('.gallery-item-4', {
				speed: 2.5,
				center: true,
			});
		}
	};

	// Initialize on window load.
	init();

	// Re-initialize on window resize.
	window.addEventListener('resize', debounce(init));
}

export function defochtelParallaxHomepageHeader() {
	const sectionHeader = document.querySelector('.section-header-home');

	if (!sectionHeader) {
		return;
	}

	let block1, block2, block3, image1, image2, image3, image4, image5;

	const resetInstances = () => {
		for (const rellax of [block1, block2, block3, image1, image2, image3, image4, image5]) {
			if (typeof rellax === 'object') {
				rellax.destroy();
			}
		}
	};

	const init = () => {
		// Reset all instances before initializing.
		// This is to prevent the rellax objects from display incorrectly when resizing the window.
		resetInstances();

		if (window.innerWidth >= 1536) {
			block1 = new Rellax('.block-item-1', {
				speed: 2,
				center: true,
			});

			block2 = new Rellax('.block-item-2', {
				speed: 2,
				center: true,
			});

			block3 = new Rellax('.block-item-3', {
				speed: 2,
				center: true,
			});

			image1 = new Rellax('.gallery-item-1', {
				speed: -1,
				center: true,
			});

			image2 = new Rellax('.gallery-item-2', {
				speed: -2,
				center: true,
			});

			image3 = new Rellax('.gallery-item-3', {
				speed: -2,
				center: true,
			});

			image4 = new Rellax('.gallery-item-4', {
				speed: -1,
				center: false,
			});

			image5 = new Rellax('.gallery-item-5', {
				speed: -2,
				center: true,
			});
		} else if (window.innerWidth >= 1280) {
			block1 = new Rellax('.block-item-1', {
				speed: 2,
				center: true,
			});

			block2 = new Rellax('.block-item-2', {
				speed: 2,
				center: true,
			});

			block3 = new Rellax('.block-item-3', {
				speed: 2,
				center: true,
			});

			image1 = new Rellax('.gallery-item-1', {
				speed: -1,
				center: true,
			});

			image2 = new Rellax('.gallery-item-2', {
				speed: -2,
				center: true,
			});

			image3 = new Rellax('.gallery-item-3', {
				speed: -2,
				center: true,
			});

			image4 = new Rellax('.gallery-item-4', {
				speed: -1,
				center: false,
			});

			image5 = new Rellax('.gallery-item-5', {
				speed: -2,
				center: true,
			});
			//
		} else if (window.innerWidth >= 1024) {
			block1 = new Rellax('.block-item-1', {
				speed: 2,
				center: true,
			});

			block2 = new Rellax('.block-item-2', {
				speed: 2,
				center: true,
			});

			block3 = new Rellax('.block-item-3', {
				speed: 2,
				center: true,
			});

			image1 = new Rellax('.gallery-item-1', {
				speed: -1,
				center: true,
			});

			image2 = new Rellax('.gallery-item-2', {
				speed: -2,
				center: true,
			});

			image3 = new Rellax('.gallery-item-3', {
				speed: -2,
				center: true,
			});

			image4 = new Rellax('.gallery-item-4', {
				speed: -1,
				center: false,
			});

			image5 = new Rellax('.gallery-item-5', {
				speed: -2,
				center: true,
			});
		} else {
			block1 = new Rellax('.block-item-1', {
				speed: 1,
				center: true,
			});

			block2 = new Rellax('.block-item-2', {
				speed: 1,
				center: true,
			});

			block3 = new Rellax('.block-item-3', {
				speed: 1,
				center: true,
			});

			image1 = new Rellax('.gallery-item-1', {
				speed: -1,
				center: true,
			});

			image2 = new Rellax('.gallery-item-2', {
				speed: -1,
				center: true,
			});

			image3 = new Rellax('.gallery-item-3', {
				speed: -1,
				center: true,
			});

			image4 = new Rellax('.gallery-item-4', {
				speed: -0.5,
				center: true,
			});

			image5 = new Rellax('.gallery-item-5', {
				speed: -1,
				center: true,
			});
		}
	};

	// Initialize on window load.
	init();

	// Re-initialize on window resize.
	window.addEventListener('resize', debounce(init));
}
